import { HttpErrorResponse } from "@angular/common/http";
import { Course } from "src/app/_models/Course";
import { CourseCategory } from "src/app/_models/CourseCategory";
import { CourseGrouped } from "src/app/_models/CourseGrouped";

export interface CourseState {
  loading: boolean;
  list: Course[];
  error: HttpErrorResponse;
  course: Course;
  inUsedCourses: Course[];
  courseGrouped: CourseGrouped[];
  courseCategories: CourseCategory[];
}

export const initialCourseState: CourseState = {
  list: [],
  loading: false,
  error: null,
  course: null,
  inUsedCourses: [],
  courseGrouped: [],
  courseCategories: []
} 